import React from 'react';
import { Construction, ArrowLeft } from 'lucide-react';
import { Button } from './ui/button';
import { useNavigate } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';

const AIPage = () => {
  const navigate = useNavigate();
  
  const goBack = () => {
    navigate('/');
  };

  return (
    <div className="ai-page">
      <Header />
      <main className="main-content">
        <section className="coming-soon-section">
          <div className="coming-soon-container">
            <div className="coming-soon-content">
              <div className="coming-soon-icon">
                <Construction size={64} />
              </div>
              
              <h1 className="coming-soon-title">
                AI Products
              </h1>
              
              <h2 className="coming-soon-subtitle">
                Coming Soon
              </h2>
              
              <p className="coming-soon-description">
                We're developing cutting-edge AI-driven solutions that will revolutionize 
                how businesses operate and innovate. Our advanced products include machine learning 
                automation, intelligent analytics, and smart response systems.
              </p>
              
              <div className="coming-soon-features">
                <div className="feature-item">
                  <h3>AI Automation</h3>
                  <p>Advanced machine learning algorithms for intelligent process automation</p>
                </div>
                <div className="feature-item">
                  <h3>Smart Analytics</h3>
                  <p>Intelligent data analysis and insights for informed decision making</p>
                </div>
                <div className="feature-item">
                  <h3>Predictive Intelligence</h3>
                  <p>Forecasting trends and patterns to optimize business operations</p>
                </div>
              </div>
              
              <div className="coming-soon-actions">
                <Button 
                  onClick={() => navigate('/#contact')}
                  className="btn-primary"
                >
                  Contact Us
                </Button>
                <Button 
                  onClick={goBack}
                  variant="secondary" 
                  className="btn-secondary"
                >
                  <ArrowLeft size={18} />
                  Back to Home
                </Button>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default AIPage;